import React, {Component} from 'react';
import '../style/TradeTable.css';

import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

class TradeTable extends Component {
  constructor(props) {
    super(props);


    this.state = {
      defaultColDef: {
        width: 50,
        resizable: false,
        filter: 'agTextColumnFilter'
      },
      columnDefs: [
        {
          headerName: 'Trade #', field: 'trade_number', resizable: true, width: 50, maxWidth: 75,
          cellStyle: function (params) {
            if (params.value === " ") {
              return {color: 'cyan', backgroundColor: 'darkgray'};
            } else {
              return {color: 'cyan', backgroundColor: 'gray'};
            }
          }
        },
        {
          headerName: 'Type', field: 'type', resizable: true, width: 50, maxWidth: 125,
          cellStyle: function (params) {
            if (params.node.rowIndex % 2 === 0) {
              //mark police cells as red
              return {color: 'cyan', backgroundColor: 'gray'};
            } else {
              return {color: 'cyan', backgroundColor: 'darkgray'};
            }
          }
        },
        {
          headerName: 'Signal', field: 'signal', resizable: true, width: 50, maxWidth: 75,
          cellStyle: function (params) {
            if (params.node.rowIndex % 2 === 0) {
              //mark police cells as red
              return {color: 'darkorange', backgroundColor: 'gray'};
            } else {
              return {color: 'darkorange', backgroundColor: 'darkgray'};
            }
          }
        },
        {
          headerName: 'Date/Time', field: 'date_time', resizable: true, width: 50, maxWidth: 200,
          cellStyle: function (params) {
            if (params.node.rowIndex % 2 === 0) {
              //mark police cells as red
              return {color: 'cyan', backgroundColor: 'gray'};
            } else {
              return {color: 'cyan', backgroundColor: 'darkgray'};
            }
          }
        },
        {
          headerName: 'Price', field: 'price', resizable: true, width: 50, maxWidth: 100,
          cellStyle: function (params) {
            if (params.node.rowIndex % 2 === 0) {
              //mark police cells as red
              return {color: 'cyan', backgroundColor: 'gray'};
            } else {
              return {color: 'cyan', backgroundColor: 'darkgray'};
            }
          }
        },
        {
          headerName: 'Contracts', field: 'contracts', resizable: true, width: 50, maxWidth: 100,
          cellStyle: function (params) {
            if (params.node.rowIndex % 2 === 0) {
              //mark police cells as red
              return {color: 'cyan', backgroundColor: 'gray'};
            } else {
              return {color: 'cyan', backgroundColor: 'darkgray'};
            }
          }
        },
        {
          headerName: 'Profit', field: 'profit', resizable: true, width: 50, maxWidth: 100,
          cellStyle: function (params) {
            if (params.value === "") {
              //mark police cells as red
              return {color: 'red', backgroundColor: 'gray'};
            } else {
              if (params.value < 0)
                return {color: 'black', backgroundColor: 'red'};
              else
                return {color: 'black', backgroundColor: 'green'};
            }
          }
        },
        {
          headerName: 'Drawdown %', field: 'drawdown', resizable: true, width: 50, maxWidth: 75,
          cellStyle: function (params) {
            if (params.node.rowIndex % 2 === 0) {
              //mark police cells as red
              return {color: 'cyan', backgroundColor: 'gray'};
            } else {
              return {color: 'cyan', backgroundColor: 'darkgray'};
            }
          }
        },
        {
          headerName: 'Cum. Profitz', field: 'cum_profit', resizable: true, width: 50, maxWidth: 100,
          cellStyle: function (params) {
            if (params.node.rowIndex % 2 === 0) {
              //mark police cells as red
              return {color: 'cyan', backgroundColor: 'gray'};
            } else {
              return {color: 'cyan', backgroundColor: 'darkgray'};
            }
          }
        },
        {headerName: ' ', field: 'xxx', type: 'leftAligned', flex: 1}

      ],
      rowData: [
        {
          trade_number: "1",
          type: "Entry Short",
          signal: "S",
          date_time: "12/31/19 23:00",
          price: "7195.94",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: ""
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "1/2/20 23:00",
          price: "6942.82",
          contracts: "0.138927",
          profit: "35.17",
          drawdown: "-0.0058",
          cum_profit: " "
        },
        {
          trade_number: "2",
          type: "Entry Long",
          signal: "B",
          date_time: "1/2/20 23:00",
          price: "6942.82",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: ""
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "1/9/20 23:00",
          price: "7807.07",
          contracts: "0.144281",
          profit: "124.69",
          drawdown: "-0.0013",
          cum_profit: ""
        },
        {
          trade_number: "3",
          type: "Entry Short",
          signal: "S",
          date_time: "1/9/20 23:00",
          price: "7807.07",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: ""
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "1/10/20 5:00",
          price: "7713.2",
          contracts: "0.128321",
          profit: "12.05",
          drawdown: "-0.0001",
          cum_profit: "171.91"
        },
        {
          trade_number: "4",
          type: "Entry Long",
          signal: "B",
          date_time: "1/10/20 5:00",
          price: "7713.2",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "171.91"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "1/19/20 5:00",
          price: "9050.51",
          contracts: "0.129741",
          profit: "173.5",
          drawdown: "-0.006",
          cum_profit: "345.41"
        },
        {
          trade_number: "5",
          type: "Entry Short",
          signal: "S",
          date_time: "1/19/20 5:00",
          price: "9050.51",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "345.41"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "1/19/20 17:00",
          price: "8715.25",
          contracts: "0.110865",
          profit: "37.17",
          drawdown: "-0.0022",
          cum_profit: "382.58"
        },
        {
          trade_number: "6",
          type: "Entry Long",
          signal: "B",
          date_time: "1/19/20 17:00",
          price: "8715.25",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "382.58"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "1/19/20 20:00",
          price: "8664.41",
          contracts: "0.115146",
          profit: "-5.85",
          drawdown: "-0.0282",
          cum_profit: "376.73"
        },
        {
          trade_number: "7",
          type: "Entry Short",
          signal: "S",
          date_time: "1/19/20 20:00",
          price: "8664.41",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "376.73"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "1/21/20 14:00",
          price: "8612.47",
          contracts: "0.115866",
          profit: "6.02",
          drawdown: "-0.0088",
          cum_profit: "382.75"
        },
        {
          trade_number: "8",
          type: "Entry Long",
          signal: "B",
          date_time: "1/21/20 14:00",
          price: "8612.47",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "382.75"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "1/22/20 2:00",
          price: "8733.39",
          contracts: "0.116566",
          profit: "14.1",
          drawdown: "-0.0154",
          cum_profit: "396.85"
        },
        {
          trade_number: "9",
          type: "Entry Short",
          signal: "S",
          date_time: "1/22/20 2:00",
          price: "8733.39",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "396.85"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "1/26/20 11:00",
          price: "8427.98",
          contracts: "0.114986",
          profit: "35.12",
          drawdown: "-0.0068",
          cum_profit: "431.97"
        },
        {
          trade_number: "10",
          type: "Entry Long",
          signal: "B",
          date_time: "1/26/20 11:00",
          price: "8427.98",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "431.97"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "2/3/20 23:00",
          price: "9266.35",
          contracts: "0.11921",
          profit: "99.94",
          drawdown: "-0.0005",
          cum_profit: "531.91"
        },
        {
          trade_number: "11",
          type: "Entry Short",
          signal: "S",
          date_time: "2/3/20 23:00",
          price: "9266.35",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "531.91"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "2/5/20 5:00",
          price: "9236.02",
          contracts: "0.108491",
          profit: "3.29",
          drawdown: "-0.0045",
          cum_profit: "535.2"
        },
        {
          trade_number: "12",
          type: "Entry Long",
          signal: "B",
          date_time: "2/5/20 5:00",
          price: "9236.02",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "535.2"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "2/10/20 20:00",
          price: "9767.5",
          contracts: "0.108744",
          profit: "57.8",
          drawdown: "-0.0001",
          cum_profit: "593"
        },
        {
          trade_number: "13",
          type: "Entry Short",
          signal: "S",
          date_time: "2/10/20 20:00",
          price: "9767.5",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "593"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "2/11/20 2:00",
          price: "9769.05",
          contracts: "0.102992",
          profit: "-0.16",
          drawdown: "-0.0046",
          cum_profit: "592.84"
        },
        {
          trade_number: "14",
          type: "Entry Long",
          signal: "B",
          date_time: "2/11/20 2:00",
          price: "9769.05",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "592.84"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "2/15/20 11:00",
          price: "9967.82",
          contracts: "0.10298",
          profit: "20.47",
          drawdown: "-0.005",
          cum_profit: "613.31"
        },
        {
          trade_number: "15",
          type: "Entry Short",
          signal: "S",
          date_time: "2/15/20 11:00",
          price: "9967.82",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "613.31"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "2/18/20 11:00",
          price: "9854.59",
          contracts: "0.100848",
          profit: "11.42",
          drawdown: "-0.0131",
          cum_profit: "624.73"
        },
        {
          trade_number: "16",
          type: "Entry Long",
          signal: "B",
          date_time: "2/18/20 11:00",
          price: "9854.59",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "624.73"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "2/19/20 17:00",
          price: "9620.73",
          contracts: "0.102019",
          profit: "-23.86",
          drawdown: "-0.0551",
          cum_profit: "600.87"
        },
        {
          trade_number: "17",
          type: "Entry Short",
          signal: "S",
          date_time: "2/19/20 17:00",
          price: "9620.73",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "600.87"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "2/22/20 23:00",
          price: "9820",
          contracts: "0.104549",
          profit: "-20.83",
          drawdown: "-0.0207",
          cum_profit: "580.04"
        },
        {
          trade_number: "18",
          type: "Entry Long",
          signal: "B",
          date_time: "2/22/20 23:00",
          price: "9820",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "580.04"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "2/23/20 20:00",
          price: "9977.27",
          contracts: "0.102439",
          profit: "16.11",
          drawdown: "0",
          cum_profit: "596.15"
        },
        {
          trade_number: "19",
          type: "Entry Short",
          signal: "S",
          date_time: "2/23/20 20:00",
          price: "9977.27",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "596.15"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "2/24/20 5:00",
          price: "9720",
          contracts: "0.100912",
          profit: "25.96",
          drawdown: "0",
          cum_profit: "622.11"
        },
        {
          trade_number: "20",
          type: "Entry Long",
          signal: "B",
          date_time: "2/24/20 5:00",
          price: "9720",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "622.11"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "2/24/20 8:00",
          price: "9802.5",
          contracts: "0.103601",
          profit: "8.55",
          drawdown: "-0.0017",
          cum_profit: "630.66"
        },
        {
          trade_number: "21",
          type: "Entry Short",
          signal: "S",
          date_time: "2/24/20 8:00",
          price: "9802.5",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "630.66"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "3/2/20 11:00",
          price: "8828.88",
          contracts: "0.102658",
          profit: "99.95",
          drawdown: "-0.0035",
          cum_profit: "730.61"
        },
        {
          trade_number: "22",
          type: "Entry Long",
          signal: "B",
          date_time: "3/2/20 11:00",
          price: "8828.88",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "730.61"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "3/2/20 23:00",
          price: "8873.68",
          contracts: "0.113997",
          profit: "5.11",
          drawdown: "-0.0018",
          cum_profit: "735.72"
        },
        {
          trade_number: "23",
          type: "Entry Short",
          signal: "S",
          date_time: "3/2/20 23:00",
          price: "8873.68",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "735.72"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "3/3/20 5:00",
          price: "8832.44",
          contracts: "0.113441",
          profit: "4.68",
          drawdown: "0",
          cum_profit: "740.4"
        },
        {
          trade_number: "24",
          type: "Entry Long",
          signal: "B",
          date_time: "3/3/20 5:00",
          price: "8832.44",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "740.4"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "3/3/20 8:00",
          price: "8806.55",
          contracts: "0.11407",
          profit: "-2.95",
          drawdown: "-0.0062",
          cum_profit: "737.45"
        },
        {
          trade_number: "25",
          type: "Entry Short",
          signal: "S",
          date_time: "3/3/20 8:00",
          price: "8806.55",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "737.45"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "3/4/20 20:00",
          price: "8871.4",
          contracts: "0.114506",
          profit: "-7.43",
          drawdown: "-0.01",
          cum_profit: "730.02"
        },
        {
          trade_number: "26",
          type: "Entry Long",
          signal: "B",
          date_time: "3/4/20 20:00",
          price: "8871.4",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "730.02"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "3/7/20 11:00",
          price: "9138.58",
          contracts: "0.113622",
          profit: "30.36",
          drawdown: "-0.0037",
          cum_profit: "760.38"
        },
        {
          trade_number: "27",
          type: "Entry Short",
          signal: "S",
          date_time: "3/7/20 11:00",
          price: "9138.58",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "760.38"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "3/19/20 6:00",
          price: "5616.34",
          contracts: "0.110354",
          profit: "388.69",
          drawdown: "-0.0088",
          cum_profit: "1149.07"
        },
        {
          trade_number: "28",
          type: "Entry Long",
          signal: "B",
          date_time: "3/19/20 6:00",
          price: "5616.34",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1149.07"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "3/22/20 12:00",
          price: "6092.4",
          contracts: "0.180096",
          profit: "85.74",
          drawdown: "-0.0088",
          cum_profit: "1234.81"
        },
        {
          trade_number: "29",
          type: "Entry Short",
          signal: "S",
          date_time: "3/22/20 12:00",
          price: "6092.4",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1234.81"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "3/23/20 9:00",
          price: "6339.21",
          contracts: "0.166303",
          profit: "-41.05",
          drawdown: "-0.0497",
          cum_profit: "1193.76"
        },
        {
          trade_number: "30",
          type: "Entry Long",
          signal: "B",
          date_time: "3/23/20 9:00",
          price: "6339.21",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1193.76"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "3/27/20 18:00",
          price: "6683.05",
          contracts: "0.159733",
          profit: "54.92",
          drawdown: "-0.0291",
          cum_profit: "1248.68"
        },
        {
          trade_number: "31",
          type: "Entry Short",
          signal: "S",
          date_time: "3/27/20 18:00",
          price: "6683.05",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1248.68"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "3/30/20 6:00",
          price: "6266.68",
          contracts: "0.151385",
          profit: "63.03",
          drawdown: "-0.0008",
          cum_profit: "1311.71"
        },
        {
          trade_number: "32",
          type: "Entry Long",
          signal: "B",
          date_time: "3/30/20 6:00",
          price: "6266.68",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1311.71"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "3/30/20 9:00",
          price: "6322.57",
          contracts: "0.161725",
          profit: "9.04",
          drawdown: "-0.0004",
          cum_profit: "1320.75"
        },
        {
          trade_number: "33",
          type: "Entry Short",
          signal: "S",
          date_time: "3/30/20 9:00",
          price: "6322.57",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1320.75"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "3/30/20 15:00",
          price: "6380.47",
          contracts: "0.160244",
          profit: "-9.28",
          drawdown: "-0.0213",
          cum_profit: "1311.47"
        },
        {
          trade_number: "34",
          type: "Entry Long",
          signal: "B",
          date_time: "3/30/20 15:00",
          price: "6380.47",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1311.47"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "3/31/20 21:00",
          price: "6305.28",
          contracts: "0.158991",
          profit: "-11.95",
          drawdown: "-0.0204",
          cum_profit: "1299.52"
        },
        {
          trade_number: "35",
          type: "Entry Short",
          signal: "S",
          date_time: "3/31/20 21:00",
          price: "6305.28",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1299.52"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "4/1/20 18:00",
          price: "6373.89",
          contracts: "0.160456",
          profit: "-11.01",
          drawdown: "-0.019",
          cum_profit: "1288.51"
        },
        {
          trade_number: "36",
          type: "Entry Long",
          signal: "B",
          date_time: "4/1/20 18:00",
          price: "6373.89",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1288.51"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "4/10/20 0:00",
          price: "7177.65",
          contracts: "0.159118",
          profit: "127.89",
          drawdown: "-0.0006",
          cum_profit: "1416.4"
        },
        {
          trade_number: "37",
          type: "Entry Short",
          signal: "S",
          date_time: "4/10/20 0:00",
          price: "7177.65",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1416.4"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "4/12/20 12:00",
          price: "7040.11",
          contracts: "0.141234",
          profit: "19.43",
          drawdown: "0",
          cum_profit: "1435.83"
        },
        {
          trade_number: "38",
          type: "Entry Long",
          signal: "B",
          date_time: "4/12/20 12:00",
          price: "7040.11",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1435.83"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "4/12/20 18:00",
          price: "7128.02",
          contracts: "0.144207",
          profit: "12.68",
          drawdown: "-0.0014",
          cum_profit: "1448.51"
        },
        {
          trade_number: "39",
          type: "Entry Short",
          signal: "S",
          date_time: "4/12/20 18:00",
          price: "7128.02",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1448.51"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "4/16/20 3:00",
          price: "6699.33",
          contracts: "0.142323",
          profit: "61.01",
          drawdown: "-0.0031",
          cum_profit: "1509.52"
        },
        {
          trade_number: "40",
          type: "Entry Long",
          signal: "B",
          date_time: "4/16/20 3:00",
          price: "6699.33",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1509.52"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "4/20/20 6:00",
          price: "7155.3",
          contracts: "0.151805",
          profit: "69.22",
          drawdown: "-0.0006",
          cum_profit: "1578.74"
        },
        {
          trade_number: "41",
          type: "Entry Short",
          signal: "S",
          date_time: "4/20/20 6:00",
          price: "7155.3",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1578.74"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "4/20/20 9:00",
          price: "7045",
          contracts: "0.141883",
          profit: "15.65",
          drawdown: "-0.0008",
          cum_profit: "1594.39"
        },
        {
          trade_number: "42",
          type: "Entry Long",
          signal: "B",
          date_time: "4/20/20 9:00",
          price: "7045",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1594.39"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "4/20/20 12:00",
          price: "7079.4",
          contracts: "0.144193",
          profit: "4.96",
          drawdown: "-0.0043",
          cum_profit: "1599.35"
        },
        {
          trade_number: "43",
          type: "Entry Short",
          signal: "S",
          date_time: "4/20/20 12:00",
          price: "7079.4",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1599.35"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "4/22/20 9:00",
          price: "6966.18",
          contracts: "0.143436",
          profit: "16.24",
          drawdown: "-0.0024",
          cum_profit: "1615.59"
        },
        {
          trade_number: "44",
          type: "Entry Long",
          signal: "B",
          date_time: "4/22/20 9:00",
          price: "6966.18",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1615.59"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "5/9/20 21:00",
          price: "8705.04",
          contracts: "0.145821",
          profit: "253.56",
          drawdown: "-0.0014",
          cum_profit: "1869.15"
        },
        {
          trade_number: "45",
          type: "Entry Short",
          signal: "S",
          date_time: "5/9/20 21:00",
          price: "8705.04",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1869.15"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "5/13/20 6:00",
          price: "8924.99",
          contracts: "0.116938",
          profit: "-25.72",
          drawdown: "-0.0549",
          cum_profit: "1843.43"
        },
        {
          trade_number: "46",
          type: "Entry Long",
          signal: "B",
          date_time: "5/13/20 6:00",
          price: "8924.99",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1843.43"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "5/15/20 15:00",
          price: "9483.77",
          contracts: "0.114194",
          profit: "63.81",
          drawdown: "-0.0028",
          cum_profit: "1907.24"
        },
        {
          trade_number: "47",
          type: "Entry Short",
          signal: "S",
          date_time: "5/15/20 15:00",
          price: "9483.77",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1907.24"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "5/15/20 18:00",
          price: "9414.6",
          contracts: "0.107489",
          profit: "7.44",
          drawdown: "-0.0029",
          cum_profit: "1914.68"
        },
        {
          trade_number: "48",
          type: "Entry Long",
          signal: "B",
          date_time: "5/15/20 18:00",
          price: "9414.6",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1914.68"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "5/16/20 12:00",
          price: "9379.18",
          contracts: "0.108169",
          profit: "-3.83",
          drawdown: "-0.0211",
          cum_profit: "1910.85"
        },
        {
          trade_number: "49",
          type: "Entry Short",
          signal: "S",
          date_time: "5/16/20 12:00",
          price: "9379.18",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1910.85"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "5/16/20 15:00",
          price: "9276.69",
          contracts: "0.108716",
          profit: "11.14",
          drawdown: "-0.0029",
          cum_profit: "1921.99"
        },
        {
          trade_number: "50",
          type: "Entry Long",
          signal: "B",
          date_time: "5/16/20 15:00",
          price: "9276.69",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1921.99"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "5/20/20 12:00",
          price: "9411.62",
          contracts: "0.10986",
          profit: "14.82",
          drawdown: "-0.019",
          cum_profit: "1936.81"
        },
        {
          trade_number: "51",
          type: "Entry Short",
          signal: "S",
          date_time: "5/20/20 12:00",
          price: "9411.62",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1936.81"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "5/20/20 15:00",
          price: "9537.21",
          contracts: "0.1083",
          profit: "-13.6",
          drawdown: "-0.0149",
          cum_profit: "1923.21"
        },
        {
          trade_number: "52",
          type: "Entry Long",
          signal: "B",
          date_time: "5/20/20 15:00",
          price: "9537.21",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1923.21"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "5/20/20 18:00",
          price: "9543.19",
          contracts: "0.106871",
          profit: "0.64",
          drawdown: "-0.0059",
          cum_profit: "1923.85"
        },
        {
          trade_number: "53",
          type: "Entry Short",
          signal: "S",
          date_time: "5/20/20 18:00",
          price: "9543.19",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1923.85"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "5/27/20 6:00",
          price: "8924.98",
          contracts: "0.106802",
          profit: "66.03",
          drawdown: "-0.0032",
          cum_profit: "1989.88"
        },
        {
          trade_number: "54",
          type: "Entry Long",
          signal: "B",
          date_time: "5/27/20 6:00",
          price: "8924.98",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "1989.88"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/2/20 15:00",
          price: "9510.12",
          contracts: "0.114214",
          profit: "66.83",
          drawdown: "-0.0003",
          cum_profit: "2056.71"
        },
        {
          trade_number: "55",
          type: "Entry Short",
          signal: "S",
          date_time: "6/2/20 15:00",
          price: "9510.12",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2056.71"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/3/20 6:00",
          price: "9525.89",
          contracts: "0.107347",
          profit: "-1.69",
          drawdown: "-0.0047",
          cum_profit: "2055.02"
        },
        {
          trade_number: "56",
          type: "Entry Long",
          signal: "B",
          date_time: "6/3/20 6:00",
          price: "9525.89",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2055.02"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/5/20 21:00",
          price: "9585.4",
          contracts: "0.107134",
          profit: "6.38",
          drawdown: "-0.0101",
          cum_profit: "2061.4"
        },
        {
          trade_number: "57",
          type: "Entry Short",
          signal: "S",
          date_time: "6/5/20 21:00",
          price: "9585.4",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2061.4"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/6/20 0:00",
          price: "9620.57",
          contracts: "0.106363",
          profit: "-3.74",
          drawdown: "-0.0052",
          cum_profit: "2057.66"
        },
        {
          trade_number: "58",
          type: "Entry Long",
          signal: "B",
          date_time: "6/6/20 0:00",
          price: "9620.57",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2057.66"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/6/20 3:00",
          price: "9606.08",
          contracts: "0.105998",
          profit: "-1.54",
          drawdown: "-0.0047",
          cum_profit: "2056.12"
        },
        {
          trade_number: "59",
          type: "Entry Short",
          signal: "S",
          date_time: "6/6/20 3:00",
          price: "9606.08",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2056.12"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/6/20 6:00",
          price: "9672.88",
          contracts: "0.106257",
          profit: "-7.1",
          drawdown: "-0.0096",
          cum_profit: "2049.02"
        },
        {
          trade_number: "60",
          type: "Entry Long",
          signal: "B",
          date_time: "6/6/20 6:00",
          price: "9672.88",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2049.02"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/6/20 12:00",
          price: "9654.08",
          contracts: "0.105556",
          profit: "-1.98",
          drawdown: "-0.0076",
          cum_profit: "2047.04"
        },
        {
          trade_number: "61",
          type: "Entry Short",
          signal: "S",
          date_time: "6/6/20 12:00",
          price: "9654.08",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2047.04"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/6/20 15:00",
          price: "9631.33",
          contracts: "0.105772",
          profit: "2.41",
          drawdown: "-0.0015",
          cum_profit: "2049.45"
        },
        {
          trade_number: "62",
          type: "Entry Long",
          signal: "B",
          date_time: "6/6/20 15:00",
          price: "9631.33",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2049.45"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/7/20 6:00",
          price: "9622.54",
          contracts: "0.105986",
          profit: "-0.93",
          drawdown: "-0.0083",
          cum_profit: "2048.52"
        },
        {
          trade_number: "63",
          type: "Entry Short",
          signal: "S",
          date_time: "6/7/20 6:00",
          price: "9622.54",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2048.52"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/7/20 15:00",
          price: "9540.82",
          contracts: "0.106093",
          profit: "8.67",
          drawdown: "-0.0018",
          cum_profit: "2057.19"
        },
        {
          trade_number: "64",
          type: "Entry Long",
          signal: "B",
          date_time: "6/7/20 15:00",
          price: "9540.82",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2057.19"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/11/20 9:00",
          price: "9710.27",
          contracts: "0.107053",
          profit: "18.14",
          drawdown: "-0.002",
          cum_profit: "2075.33"
        },
        {
          trade_number: "65",
          type: "Entry Short",
          signal: "S",
          date_time: "6/11/20 9:00",
          price: "9710.27",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2075.33"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/15/20 15:00",
          price: "9422.3",
          contracts: "0.105171",
          profit: "30.29",
          drawdown: "-0.0026",
          cum_profit: "2105.62"
        },
        {
          trade_number: "66",
          type: "Entry Long",
          signal: "B",
          date_time: "6/15/20 15:00",
          price: "9422.3",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2105.62"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/15/20 18:00",
          price: "9449.2",
          contracts: "0.108392",
          profit: "2.92",
          drawdown: "-0.0032",
          cum_profit: "2108.54"
        },
        {
          trade_number: "67",
          type: "Entry Short",
          signal: "S",
          date_time: "6/15/20 18:00",
          price: "9449.2",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2108.54"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/16/20 0:00",
          price: "9575.28",
          contracts: "0.108106",
          profit: "-13.63",
          drawdown: "-0.0156",
          cum_profit: "2094.91"
        },
        {
          trade_number: "68",
          type: "Entry Long",
          signal: "B",
          date_time: "6/16/20 0:00",
          price: "9575.28",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2094.91"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/16/20 9:00",
          price: "9562.37",
          contracts: "0.106671",
          profit: "-1.38",
          drawdown: "-0.0131",
          cum_profit: "2093.53"
        },
        {
          trade_number: "69",
          type: "Entry Short",
          signal: "S",
          date_time: "6/16/20 9:00",
          price: "9562.37",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2093.53"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/16/20 12:00",
          price: "9444.68",
          contracts: "0.106792",
          profit: "12.57",
          drawdown: "-0.0033",
          cum_profit: "2106.1"
        },
        {
          trade_number: "70",
          type: "Entry Long",
          signal: "B",
          date_time: "6/16/20 12:00",
          price: "9444.68",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2106.1"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/16/20 21:00",
          price: "9475.89",
          contracts: "0.108109",
          profit: "3.37",
          drawdown: "-0.0019",
          cum_profit: "2109.47"
        },
        {
          trade_number: "71",
          type: "Entry Short",
          signal: "S",
          date_time: "6/16/20 21:00",
          price: "9475.89",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2109.47"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/17/20 0:00",
          price: "9454.62",
          contracts: "0.107684",
          profit: "2.29",
          drawdown: "-0.001",
          cum_profit: "2111.76"
        },
        {
          trade_number: "72",
          type: "Entry Long",
          signal: "B",
          date_time: "6/17/20 0:00",
          price: "9454.62",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2111.76"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/17/20 9:00",
          price: "9495",
          contracts: "0.108001",
          profit: "4.36",
          drawdown: "-0.0029",
          cum_profit: "2116.12"
        },
        {
          trade_number: "73",
          type: "Entry Short",
          signal: "S",
          date_time: "6/17/20 9:00",
          price: "9495",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2116.12"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/17/20 18:00",
          price: "9406.61",
          contracts: "0.107493",
          profit: "9.5",
          drawdown: "-0.0075",
          cum_profit: "2125.62"
        },
        {
          trade_number: "74",
          type: "Entry Long",
          signal: "B",
          date_time: "6/17/20 18:00",
          price: "9406.61",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2125.62"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/17/20 21:00",
          price: "9429.15",
          contracts: "0.108565",
          profit: "2.45",
          drawdown: "-0.0017",
          cum_profit: "2128.07"
        },
        {
          trade_number: "75",
          type: "Entry Short",
          signal: "S",
          date_time: "6/17/20 21:00",
          price: "9429.15",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2128.07"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/18/20 3:00",
          price: "9426.7",
          contracts: "0.108376",
          profit: "0.27",
          drawdown: "-0.0014",
          cum_profit: "2128.34"
        },
        {
          trade_number: "76",
          type: "Entry Long",
          signal: "B",
          date_time: "6/18/20 3:00",
          price: "9426.7",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2128.34"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/18/20 12:00",
          price: "9373.42",
          contracts: "0.108344",
          profit: "-5.77",
          drawdown: "-0.0067",
          cum_profit: "2122.57"
        },
        {
          trade_number: "77",
          type: "Entry Short",
          signal: "S",
          date_time: "6/18/20 12:00",
          price: "9373.42",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2122.57"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/20/20 18:00",
          price: "9338.5",
          contracts: "0.108989",
          profit: "3.81",
          drawdown: "-0.006",
          cum_profit: "2126.38"
        },
        {
          trade_number: "78",
          type: "Entry Long",
          signal: "B",
          date_time: "6/20/20 18:00",
          price: "9338.5",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2126.38"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/21/20 3:00",
          price: "9372.57",
          contracts: "0.10943",
          profit: "3.73",
          drawdown: "0",
          cum_profit: "2130.11"
        },
        {
          trade_number: "79",
          type: "Entry Short",
          signal: "S",
          date_time: "6/21/20 3:00",
          price: "9372.57",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2130.11"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "6/21/20 21:00",
          price: "9310.6",
          contracts: "0.108949",
          profit: "6.75",
          drawdown: "-0.0016",
          cum_profit: "2136.86"
        },
        {
          trade_number: "80",
          type: "Entry Long",
          signal: "B",
          date_time: "6/21/20 21:00",
          price: "9310.6",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2136.86"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "6/24/20 6:00",
          price: "9515.32",
          contracts: "0.109641",
          profit: "22.45",
          drawdown: "0",
          cum_profit: "2159.31"
        },
        {
          trade_number: "81",
          type: "Entry Short",
          signal: "S",
          date_time: "6/24/20 6:00",
          price: "9515.32",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2159.31"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "7/1/20 9:00",
          price: "9166.37",
          contracts: "0.107347",
          profit: "37.46",
          drawdown: "-0.0002",
          cum_profit: "2196.77"
        },
        {
          trade_number: "82",
          type: "Entry Long",
          signal: "B",
          date_time: "7/1/20 9:00",
          price: "9166.37",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2196.77"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "7/2/20 12:00",
          price: "9043.55",
          contracts: "0.111432",
          profit: "-13.69",
          drawdown: "-0.0145",
          cum_profit: "2183.08"
        },
        {
          trade_number: "83",
          type: "Entry Short",
          signal: "S",
          date_time: "7/2/20 12:00",
          price: "9043.55",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2183.08"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "7/4/20 12:00",
          price: "9066.76",
          contracts: "0.112989",
          profit: "-2.62",
          drawdown: "-0.0119",
          cum_profit: "2180.46"
        },
        {
          trade_number: "84",
          type: "Entry Long",
          signal: "B",
          date_time: "7/4/20 12:00",
          price: "9066.76",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2180.46"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "7/4/20 21:00",
          price: "9133.68",
          contracts: "0.112697",
          profit: "7.54",
          drawdown: "-0.0019",
          cum_profit: "2188"
        },
        {
          trade_number: "85",
          type: "Entry Short",
          signal: "S",
          date_time: "7/4/20 21:00",
          price: "9133.68",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2188"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "7/6/20 0:00",
          price: "9089.55",
          contracts: "0.11188",
          profit: "4.94",
          drawdown: "-0.0008",
          cum_profit: "2192.94"
        },
        {
          trade_number: "86",
          type: "Entry Long",
          signal: "B",
          date_time: "7/6/20 0:00",
          price: "9089.55",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2192.94"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "7/9/20 12:00",
          price: "9204.23",
          contracts: "0.112464",
          profit: "12.9",
          drawdown: "-0.0011",
          cum_profit: "2205.84"
        },
        {
          trade_number: "87",
          type: "Entry Short",
          signal: "S",
          date_time: "7/9/20 12:00",
          price: "9204.23",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2205.84"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "7/10/20 18:00",
          price: "9214.73",
          contracts: "0.111032",
          profit: "-1.17",
          drawdown: "-0.0058",
          cum_profit: "2204.67"
        },
        {
          trade_number: "88",
          type: "Entry Long",
          signal: "B",
          date_time: "7/10/20 18:00",
          price: "9214.73",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2204.67"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "7/11/20 6:00",
          price: "9205.31",
          contracts: "0.110855",
          profit: "-1.04",
          drawdown: "-0.0038",
          cum_profit: "2203.63"
        },
        {
          trade_number: "89",
          type: "Entry Short",
          signal: "S",
          date_time: "7/11/20 6:00",
          price: "9205.31",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2203.63"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "7/11/20 21:00",
          price: "9253.76",
          contracts: "0.111026",
          profit: "-5.38",
          drawdown: "-0.0066",
          cum_profit: "2198.25"
        },
        {
          trade_number: "90",
          type: "Entry Long",
          signal: "B",
          date_time: "7/11/20 21:00",
          price: "9253.76",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2198.25"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "7/12/20 6:00",
          price: "9261.08",
          contracts: "0.110455",
          profit: "0.81",
          drawdown: "-0.0015",
          cum_profit: "2199.06"
        },
        {
          trade_number: "91",
          type: "Entry Short",
          signal: "S",
          date_time: "7/12/20 6:00",
          price: "9261.08",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2199.06"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "7/12/20 18:00",
          price: "9269.03",
          contracts: "0.110284",
          profit: "-0.88",
          drawdown: "-0.0094",
          cum_profit: "2198.18"
        },
        {
          trade_number: "92",
          type: "Entry Long",
          signal: "B",
          date_time: "7/12/20 18:00",
          price: "9269.03",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2198.18"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "7/13/20 15:00",
          price: "9287.98",
          contracts: "0.110242",
          profit: "2.09",
          drawdown: "-0.0027",
          cum_profit: "2200.27"
        },
        {
          trade_number: "93",
          type: "Entry Short",
          signal: "S",
          date_time: "7/13/20 15:00",
          price: "9287.98",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2200.27"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "7/14/20 15:00",
          price: "9252.83",
          contracts: "0.110065",
          profit: "3.87",
          drawdown: "-0.0003",
          cum_profit: "2204.14"
        },
        {
          trade_number: "94",
          type: "Entry Long",
          signal: "B",
          date_time: "7/14/20 15:00",
          price: "9252.83",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2204.14"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "7/14/20 18:00",
          price: "9246.32",
          contracts: "0.110491",
          profit: "-0.72",
          drawdown: "-0.0014",
          cum_profit: "2203.42"
        },
        {
          trade_number: "95",
          type: "Entry Short",
          signal: "S",
          date_time: "7/14/20 18:00",
          price: "9246.32",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2203.42"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "7/18/20 18:00",
          price: "9174.96",
          contracts: "0.110534",
          profit: "7.89",
          drawdown: "-0.0033",
          cum_profit: "2211.31"
        },
        {
          trade_number: "96",
          type: "Entry Long",
          signal: "B",
          date_time: "7/18/20 18:00",
          price: "9174.96",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2211.31"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "7/18/20 21:00",
          price: "9177.64",
          contracts: "0.111402",
          profit: "0.3",
          drawdown: "-0.001",
          cum_profit: "2211.61"
        },
        {
          trade_number: "97",
          type: "Entry Short",
          signal: "S",
          date_time: "7/18/20 21:00",
          price: "9177.64",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2211.61"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "7/19/20 15:00",
          price: "9162.77",
          contracts: "0.111313",
          profit: "1.66",
          drawdown: "-0.0002",
          cum_profit: "2213.27"
        },
        {
          trade_number: "98",
          type: "Entry Long",
          signal: "B",
          date_time: "7/19/20 15:00",
          price: "9162.77",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2213.27"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "7/20/20 6:00",
          price: "9185",
          contracts: "0.111606",
          profit: "2.48",
          drawdown: "-0.0015",
          cum_profit: "2215.75"
        },
        {
          trade_number: "99",
          type: "Entry Short",
          signal: "S",
          date_time: "7/20/20 6:00",
          price: "9185",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2215.75"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "7/20/20 9:00",
          price: "9163.37",
          contracts: "0.11125",
          profit: "2.41",
          drawdown: "-0.0005",
          cum_profit: "2218.16"
        },
        {
          trade_number: "100",
          type: "Entry Long",
          signal: "B",
          date_time: "7/20/20 9:00",
          price: "9163.37",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2218.16"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "7/20/20 18:00",
          price: "9173.83",
          contracts: "0.111528",
          profit: "1.17",
          drawdown: "-0.0021",
          cum_profit: "2219.33"
        },
        {
          trade_number: "101",
          type: "Entry Short",
          signal: "S",
          date_time: "7/20/20 18:00",
          price: "9173.83",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2219.33"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "7/20/20 21:00",
          price: "9171.09",
          contracts: "0.111474",
          profit: "0.31",
          drawdown: "-0.0005",
          cum_profit: "2219.64"
        },
        {
          trade_number: "102",
          type: "Entry Long",
          signal: "B",
          date_time: "7/20/20 21:00",
          price: "9171.09",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2219.64"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/9/20 12:00",
          price: "11576.33",
          contracts: "0.111464",
          profit: "268.1",
          drawdown: "-0.0008",
          cum_profit: "2487.74"
        },
        {
          trade_number: "103",
          type: "Entry Short",
          signal: "S",
          date_time: "8/9/20 12:00",
          price: "11576.33",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2487.74"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/9/20 15:00",
          price: "11641.46",
          contracts: "0.08852",
          profit: "-5.77",
          drawdown: "-0.0065",
          cum_profit: "2481.97"
        },
        {
          trade_number: "104",
          type: "Entry Long",
          signal: "B",
          date_time: "8/9/20 15:00",
          price: "11641.46",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2481.97"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/11/20 9:00",
          price: "11673.01",
          contracts: "0.088058",
          profit: "2.78",
          drawdown: "-0.0113",
          cum_profit: "2484.75"
        },
        {
          trade_number: "105",
          type: "Entry Short",
          signal: "S",
          date_time: "8/11/20 9:00",
          price: "11673.01",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2484.75"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/12/20 9:00",
          price: "11515.63",
          contracts: "0.087796",
          profit: "13.82",
          drawdown: "-0.0006",
          cum_profit: "2498.57"
        },
        {
          trade_number: "106",
          type: "Entry Long",
          signal: "B",
          date_time: "8/12/20 9:00",
          price: "11515.63",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2498.57"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/12/20 12:00",
          price: "11589.28",
          contracts: "0.089022",
          profit: "6.56",
          drawdown: "-0.0031",
          cum_profit: "2505.13"
        },
        {
          trade_number: "107",
          type: "Entry Short",
          signal: "S",
          date_time: "8/12/20 12:00",
          price: "11589.28",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2505.13"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/13/20 15:00",
          price: "11490.12",
          contracts: "0.088453",
          profit: "8.77",
          drawdown: "-0.0066",
          cum_profit: "2513.9"
        },
        {
          trade_number: "108",
          type: "Entry Long",
          signal: "B",
          date_time: "8/13/20 15:00",
          price: "11490.12",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2513.9"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/19/20 0:00",
          price: "11842.39",
          contracts: "0.08916",
          profit: "31.41",
          drawdown: "0",
          cum_profit: "2545.31"
        },
        {
          trade_number: "109",
          type: "Entry Short",
          signal: "S",
          date_time: "8/19/20 0:00",
          price: "11842.39",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2545.31"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/19/20 6:00",
          price: "11796.56",
          contracts: "0.086591",
          profit: "3.97",
          drawdown: "-0.003",
          cum_profit: "2549.28"
        },
        {
          trade_number: "110",
          type: "Entry Long",
          signal: "B",
          date_time: "8/19/20 6:00",
          price: "11796.56",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2549.28"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/19/20 9:00",
          price: "11867.68",
          contracts: "0.086922",
          profit: "6.18",
          drawdown: "-0.0051",
          cum_profit: "2555.46"
        },
        {
          trade_number: "111",
          type: "Entry Short",
          signal: "S",
          date_time: "8/19/20 9:00",
          price: "11867.68",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2555.46"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/20/20 9:00",
          price: "11781.55",
          contracts: "0.086444",
          profit: "7.45",
          drawdown: "-0.0056",
          cum_profit: "2562.91"
        },
        {
          trade_number: "112",
          type: "Entry Long",
          signal: "B",
          date_time: "8/20/20 9:00",
          price: "11781.55",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2562.91"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/20/20 21:00",
          price: "11837.35",
          contracts: "0.087053",
          profit: "4.86",
          drawdown: "-0.0034",
          cum_profit: "2567.77"
        },
        {
          trade_number: "113",
          type: "Entry Short",
          signal: "S",
          date_time: "8/20/20 21:00",
          price: "11837.35",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2567.77"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/21/20 0:00",
          price: "11870.64",
          contracts: "0.086623",
          profit: "-2.88",
          drawdown: "-0.0032",
          cum_profit: "2564.89"
        },
        {
          trade_number: "114",
          type: "Entry Long",
          signal: "B",
          date_time: "8/21/20 0:00",
          price: "11870.64",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2564.89"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/21/20 3:00",
          price: "11828.75",
          contracts: "0.086445",
          profit: "-3.62",
          drawdown: "-0.0052",
          cum_profit: "2561.27"
        },
        {
          trade_number: "115",
          type: "Entry Short",
          signal: "S",
          date_time: "8/21/20 3:00",
          price: "11828.75",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2561.27"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/24/20 3:00",
          price: "11757.32",
          contracts: "0.0867",
          profit: "6.19",
          drawdown: "-0.0029",
          cum_profit: "2567.46"
        },
        {
          trade_number: "116",
          type: "Entry Long",
          signal: "B",
          date_time: "8/24/20 3:00",
          price: "11757.32",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2567.46"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/24/20 9:00",
          price: "11780",
          contracts: "0.087288",
          profit: "1.98",
          drawdown: "-0.0014",
          cum_profit: "2569.44"
        },
        {
          trade_number: "117",
          type: "Entry Short",
          signal: "S",
          date_time: "8/24/20 9:00",
          price: "11780",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2569.44"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/24/20 12:00",
          price: "11759.52",
          contracts: "0.08707",
          profit: "1.78",
          drawdown: "-0.0019",
          cum_profit: "2571.22"
        },
        {
          trade_number: "118",
          type: "Entry Long",
          signal: "B",
          date_time: "8/24/20 12:00",
          price: "11759.52",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2571.22"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/24/20 15:00",
          price: "11739.1",
          contracts: "0.087193",
          profit: "-1.78",
          drawdown: "-0.0039",
          cum_profit: "2569.44"
        },
        {
          trade_number: "119",
          type: "Entry Short",
          signal: "S",
          date_time: "8/24/20 15:00",
          price: "11739.1",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2569.44"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/24/20 18:00",
          price: "11757.32",
          contracts: "0.087366",
          profit: "-1.59",
          drawdown: "-0.0031",
          cum_profit: "2567.85"
        },
        {
          trade_number: "120",
          type: "Entry Long",
          signal: "B",
          date_time: "8/24/20 18:00",
          price: "11757.32",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2567.85"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/24/20 21:00",
          price: "11746.4",
          contracts: "0.087236",
          profit: "-0.95",
          drawdown: "-0.0021",
          cum_profit: "2566.9"
        },
        {
          trade_number: "121",
          type: "Entry Short",
          signal: "S",
          date_time: "8/24/20 21:00",
          price: "11746.4",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2566.9"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/28/20 15:00",
          price: "11493",
          contracts: "0.087308",
          profit: "22.12",
          drawdown: "-0.0022",
          cum_profit: "2589.02"
        },
        {
          trade_number: "122",
          type: "Entry Long",
          signal: "B",
          date_time: "8/28/20 15:00",
          price: "11493",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2589.02"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/28/20 21:00",
          price: "11501.96",
          contracts: "0.089285",
          profit: "0.8",
          drawdown: "-0.0026",
          cum_profit: "2589.82"
        },
        {
          trade_number: "123",
          type: "Entry Short",
          signal: "S",
          date_time: "8/28/20 21:00",
          price: "11501.96",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2589.82"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/29/20 0:00",
          price: "11504.73",
          contracts: "0.089253",
          profit: "-0.25",
          drawdown: "-0.0018",
          cum_profit: "2589.57"
        },
        {
          trade_number: "124",
          type: "Entry Long",
          signal: "B",
          date_time: "8/29/20 0:00",
          price: "11504.73",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2589.57"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/29/20 6:00",
          price: "11555.17",
          contracts: "0.089171",
          profit: "4.5",
          drawdown: "-0.0016",
          cum_profit: "2594.07"
        },
        {
          trade_number: "125",
          type: "Entry Short",
          signal: "S",
          date_time: "8/29/20 6:00",
          price: "11555.17",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2594.07"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/29/20 12:00",
          price: "11510.32",
          contracts: "0.088767",
          profit: "3.98",
          drawdown: "0",
          cum_profit: "2598.05"
        },
        {
          trade_number: "126",
          type: "Entry Long",
          signal: "B",
          date_time: "8/29/20 12:00",
          price: "11510.32",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2598.05"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "8/29/20 18:00",
          price: "11512.63",
          contracts: "0.089196",
          profit: "0.21",
          drawdown: "-0.0026",
          cum_profit: "2598.26"
        },
        {
          trade_number: "127",
          type: "Entry Short",
          signal: "S",
          date_time: "8/29/20 18:00",
          price: "11512.63",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2598.26"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "8/29/20 21:00",
          price: "11503.93",
          contracts: "0.089163",
          profit: "0.78",
          drawdown: "-0.001",
          cum_profit: "2599.04"
        },
        {
          trade_number: "128",
          type: "Entry Long",
          signal: "B",
          date_time: "8/29/20 21:00",
          price: "11503.93",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2599.04"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/2/20 6:00",
          price: "11747.89",
          contracts: "0.089177",
          profit: "21.76",
          drawdown: "-0.0004",
          cum_profit: "2620.8"
        },
        {
          trade_number: "129",
          type: "Entry Short",
          signal: "S",
          date_time: "9/2/20 6:00",
          price: "11747.89",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2620.8"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/9/20 21:00",
          price: "10272.37",
          contracts: "0.087352",
          profit: "128.89",
          drawdown: "-0.0002",
          cum_profit: "2749.69"
        },
        {
          trade_number: "130",
          type: "Entry Long",
          signal: "B",
          date_time: "9/9/20 21:00",
          price: "10272.37",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2749.69"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/10/20 3:00",
          price: "10335.68",
          contracts: "0.1",
          profit: "6.33",
          drawdown: "-0.0016",
          cum_profit: "2756.02"
        },
        {
          trade_number: "131",
          type: "Entry Short",
          signal: "S",
          date_time: "9/10/20 3:00",
          price: "10335.68",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2756.02"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/10/20 9:00",
          price: "10365.83",
          contracts: "0.09935",
          profit: "-3",
          drawdown: "-0.0047",
          cum_profit: "2753.02"
        },
        {
          trade_number: "132",
          type: "Entry Long",
          signal: "B",
          date_time: "9/10/20 9:00",
          price: "10365.83",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2753.02"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/10/20 12:00",
          price: "10426.78",
          contracts: "0.099079",
          profit: "6.04",
          drawdown: "-0.0012",
          cum_profit: "2759.06"
        },
        {
          trade_number: "133",
          type: "Entry Short",
          signal: "S",
          date_time: "9/10/20 12:00",
          price: "10426.78",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2759.06"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/11/20 18:00",
          price: "10347.72",
          contracts: "0.098566",
          profit: "7.79",
          drawdown: "-0.0019",
          cum_profit: "2766.85"
        },
        {
          trade_number: "134",
          type: "Entry Long",
          signal: "B",
          date_time: "9/11/20 18:00",
          price: "10347.72",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2766.85"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/11/20 21:00",
          price: "10349.17",
          contracts: "0.099239",
          profit: "0.14",
          drawdown: "-0.0012",
          cum_profit: "2766.99"
        },
        {
          trade_number: "135",
          type: "Entry Short",
          signal: "S",
          date_time: "9/11/20 21:00",
          price: "10349.17",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2766.99"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/12/20 0:00",
          price: "10350",
          contracts: "0.099299",
          profit: "-0.08",
          drawdown: "-0.004",
          cum_profit: "2766.91"
        },
        {
          trade_number: "136",
          type: "Entry Long",
          signal: "B",
          date_time: "9/12/20 0:00",
          price: "10350",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2766.91"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/12/20 3:00",
          price: "10334.45",
          contracts: "0.099291",
          profit: "-1.54",
          drawdown: "-0.0021",
          cum_profit: "2765.37"
        },
        {
          trade_number: "137",
          type: "Entry Short",
          signal: "S",
          date_time: "9/12/20 3:00",
          price: "10334.45",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2765.37"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/12/20 12:00",
          price: "10365.53",
          contracts: "0.099425",
          profit: "-3.09",
          drawdown: "-0.0045",
          cum_profit: "2762.28"
        },
        {
          trade_number: "138",
          type: "Entry Long",
          signal: "B",
          date_time: "9/12/20 12:00",
          price: "10365.53",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2762.28"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/13/20 6:00",
          price: "10501.11",
          contracts: "0.099189",
          profit: "13.45",
          drawdown: "-0.0016",
          cum_profit: "2775.73"
        },
        {
          trade_number: "139",
          type: "Entry Short",
          signal: "S",
          date_time: "9/13/20 6:00",
          price: "10501.11",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2775.73"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/14/20 6:00",
          price: "10368.71",
          contracts: "0.097834",
          profit: "12.95",
          drawdown: "0",
          cum_profit: "2788.68"
        },
        {
          trade_number: "140",
          type: "Entry Long",
          signal: "B",
          date_time: "9/14/20 6:00",
          price: "10368.71",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2788.68"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/20/20 9:00",
          price: "10845.83",
          contracts: "0.099105",
          profit: "47.28",
          drawdown: "-0.0001",
          cum_profit: "2835.96"
        },
        {
          trade_number: "141",
          type: "Entry Short",
          signal: "S",
          date_time: "9/20/20 9:00",
          price: "10845.83",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2835.96"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/20/20 12:00",
          price: "10840.26",
          contracts: "0.094801",
          profit: "0.53",
          drawdown: "-0.003",
          cum_profit: "2836.49"
        },
        {
          trade_number: "142",
          type: "Entry Long",
          signal: "B",
          date_time: "9/20/20 12:00",
          price: "10840.26",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2836.49"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/20/20 15:00",
          price: "10895.04",
          contracts: "0.0949",
          profit: "5.2",
          drawdown: "-0.0078",
          cum_profit: "2841.69"
        },
        {
          trade_number: "143",
          type: "Entry Short",
          signal: "S",
          date_time: "9/20/20 15:00",
          price: "10895.04",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2841.69"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/20/20 18:00",
          price: "10871.74",
          contracts: "0.094442",
          profit: "2.2",
          drawdown: "-0.0006",
          cum_profit: "2843.89"
        },
        {
          trade_number: "144",
          type: "Entry Long",
          signal: "B",
          date_time: "9/20/20 18:00",
          price: "10871.74",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2843.89"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/21/20 3:00",
          price: "10949.18",
          contracts: "0.094539",
          profit: "7.32",
          drawdown: "-0.0039",
          cum_profit: "2851.21"
        },
        {
          trade_number: "145",
          type: "Entry Short",
          signal: "S",
          date_time: "9/21/20 3:00",
          price: "10949.18",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2851.21"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/24/20 12:00",
          price: "10539.46",
          contracts: "0.09394",
          profit: "38.49",
          drawdown: "-0.0012",
          cum_profit: "2889.7"
        },
        {
          trade_number: "146",
          type: "Entry Long",
          signal: "B",
          date_time: "9/24/20 12:00",
          price: "10539.46",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2889.7"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/25/20 3:00",
          price: "10693.53",
          contracts: "0.097524",
          profit: "15.03",
          drawdown: "-0.0001",
          cum_profit: "2904.73"
        },
        {
          trade_number: "147",
          type: "Entry Short",
          signal: "S",
          date_time: "9/25/20 3:00",
          price: "10693.53",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2904.73"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/25/20 6:00",
          price: "10587.88",
          contracts: "0.096246",
          profit: "10.17",
          drawdown: "-0.0015",
          cum_profit: "2914.9"
        },
        {
          trade_number: "148",
          type: "Entry Long",
          signal: "B",
          date_time: "9/25/20 6:00",
          price: "10587.88",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2914.9"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/27/20 3:00",
          price: "10662.21",
          contracts: "0.097149",
          profit: "7.22",
          drawdown: "-0.0033",
          cum_profit: "2922.12"
        },
        {
          trade_number: "149",
          type: "Entry Short",
          signal: "S",
          date_time: "9/27/20 3:00",
          price: "10662.21",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2922.12"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/27/20 9:00",
          price: "10662.27",
          contracts: "0.096426",
          profit: "-0.01",
          drawdown: "-0.003",
          cum_profit: "2922.11"
        },
        {
          trade_number: "150",
          type: "Entry Long",
          signal: "B",
          date_time: "9/27/20 9:00",
          price: "10662.27",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2922.11"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/28/20 18:00",
          price: "10891.53",
          contracts: "0.096514",
          profit: "22.13",
          drawdown: "-0.0024",
          cum_profit: "2944.24"
        },
        {
          trade_number: "151",
          type: "Entry Short",
          signal: "S",
          date_time: "9/28/20 18:00",
          price: "10891.53",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2944.24"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/29/20 3:00",
          price: "10742",
          contracts: "0.09457",
          profit: "14.14",
          drawdown: "0",
          cum_profit: "2958.38"
        },
        {
          trade_number: "152",
          type: "Entry Long",
          signal: "B",
          date_time: "9/29/20 3:00",
          price: "10742",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2958.38"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/29/20 12:00",
          price: "10722.57",
          contracts: "0.095839",
          profit: "-1.86",
          drawdown: "-0.0039",
          cum_profit: "2956.52"
        },
        {
          trade_number: "153",
          type: "Entry Short",
          signal: "S",
          date_time: "9/29/20 12:00",
          price: "10722.57",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2956.52"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/29/20 15:00",
          price: "10731.56",
          contracts: "0.096013",
          profit: "-0.86",
          drawdown: "-0.0023",
          cum_profit: "2955.66"
        },
        {
          trade_number: "154",
          type: "Entry Long",
          signal: "B",
          date_time: "9/29/20 15:00",
          price: "10731.56",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2955.66"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/30/20 0:00",
          price: "10740.45",
          contracts: "0.095976",
          profit: "0.85",
          drawdown: "-0.0016",
          cum_profit: "2956.51"
        },
        {
          trade_number: "155",
          type: "Entry Short",
          signal: "S",
          date_time: "9/30/20 0:00",
          price: "10740.45",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2956.51"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/30/20 9:00",
          price: "10724.51",
          contracts: "0.095868",
          profit: "1.53",
          drawdown: "-0.0022",
          cum_profit: "2958.04"
        },
        {
          trade_number: "156",
          type: "Entry Long",
          signal: "B",
          date_time: "9/30/20 9:00",
          price: "10724.51",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2958.04"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "9/30/20 15:00",
          price: "10726.44",
          contracts: "0.096003",
          profit: "0.19",
          drawdown: "-0.0044",
          cum_profit: "2958.23"
        },
        {
          trade_number: "157",
          type: "Entry Short",
          signal: "S",
          date_time: "9/30/20 15:00",
          price: "10726.44",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2958.23"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "9/30/20 18:00",
          price: "10703.77",
          contracts: "0.095954",
          profit: "2.18",
          drawdown: "-0.0016",
          cum_profit: "2960.41"
        },
        {
          trade_number: "158",
          type: "Entry Long",
          signal: "B",
          date_time: "9/30/20 18:00",
          price: "10703.77",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2960.41"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "10/1/20 12:00",
          price: "10713.4",
          contracts: "0.096192",
          profit: "0.93",
          drawdown: "-0.0001",
          cum_profit: "2961.34"
        },
        {
          trade_number: "159",
          type: "Entry Short",
          signal: "S",
          date_time: "10/1/20 12:00",
          price: "10713.4",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2961.34"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "10/4/20 15:00",
          price: "10636.18",
          contracts: "0.096093",
          profit: "7.42",
          drawdown: "-0.0002",
          cum_profit: "2968.76"
        },
        {
          trade_number: "160",
          type: "Entry Long",
          signal: "B",
          date_time: "10/4/20 15:00",
          price: "10636.18",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2968.76"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "10/6/20 15:00",
          price: "10598.01",
          contracts: "0.09682",
          profit: "-3.7",
          drawdown: "-0.0069",
          cum_profit: "2965.06"
        },
        {
          trade_number: "161",
          type: "Entry Short",
          signal: "S",
          date_time: "10/6/20 15:00",
          price: "10598.01",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2965.06"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "10/7/20 12:00",
          price: "10631.26",
          contracts: "0.097102",
          profit: "-3.23",
          drawdown: "-0.0051",
          cum_profit: "2961.83"
        },
        {
          trade_number: "162",
          type: "Entry Long",
          signal: "B",
          date_time: "10/7/20 12:00",
          price: "10631.26",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2961.83"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "10/8/20 0:00",
          price: "10640.61",
          contracts: "0.09686",
          profit: "0.91",
          drawdown: "-0.003",
          cum_profit: "2962.74"
        },
        {
          trade_number: "163",
          type: "Entry Short",
          signal: "S",
          date_time: "10/8/20 0:00",
          price: "10640.61",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2962.74"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "10/8/20 9:00",
          price: "10637.9",
          contracts: "0.096728",
          profit: "0.26",
          drawdown: "-0.0013",
          cum_profit: "2963"
        },
        {
          trade_number: "164",
          type: "Entry Long",
          signal: "B",
          date_time: "10/8/20 9:00",
          price: "10637.9",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "2963"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "10/16/20 3:00",
          price: "11330.91",
          contracts: "0.096821",
          profit: "67.1",
          drawdown: "-0.002",
          cum_profit: "3030.1"
        },
        {
          trade_number: "165",
          type: "Entry Short",
          signal: "S",
          date_time: "10/16/20 3:00",
          price: "11330.91",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "3030.1"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "10/16/20 6:00",
          price: "11256.2",
          contracts: "0.090858",
          profit: "6.79",
          drawdown: "-0.0017",
          cum_profit: "3036.89"
        },
        {
          trade_number: "166",
          type: "Entry Long",
          signal: "B",
          date_time: "10/16/20 6:00",
          price: "11256.2",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "3036.89"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "10/16/20 15:00",
          price: "11376.91",
          contracts: "0.091548",
          profit: "11.05",
          drawdown: "-0.0007",
          cum_profit: "3047.94"
        },
        {
          trade_number: "167",
          type: "Entry Short",
          signal: "S",
          date_time: "10/16/20 15:00",
          price: "11376.91",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "3047.94"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "10/16/20 21:00",
          price: "11307.74",
          contracts: "0.090599",
          profit: "6.27",
          drawdown: "-0.0002",
          cum_profit: "3054.21"
        },
        {
          trade_number: "168",
          type: "Entry Long",
          signal: "B",
          date_time: "10/16/20 21:00",
          price: "11307.74",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "3054.21"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "S",
          date_time: "10/17/20 3:00",
          price: "11354.63",
          contracts: "0.091149",
          profit: "4.27",
          drawdown: "-0.001",
          cum_profit: "3058.48"
        },
        {
          trade_number: "169",
          type: "Entry Short",
          signal: "S",
          date_time: "10/17/20 3:00",
          price: "11354.63",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "3058.48"
        },
        {
          trade_number: " ",
          type: "Exit Short",
          signal: "B",
          date_time: "10/17/20 6:00",
          price: "11338.15",
          contracts: "0.090731",
          profit: "1.5",
          drawdown: "-0.0018",
          cum_profit: "3059.98"
        },
        {
          trade_number: "170",
          type: "Entry Long",
          signal: "B",
          date_time: "10/17/20 6:00",
          price: "11338.15",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "3059.98"
        },
        {
          trade_number: " ",
          type: "Exit Long",
          signal: "Open",
          date_time: "",
          price: "",
          contracts: "",
          profit: "",
          drawdown: "",
          cum_profit: "3059.98"
        }
      ]

    }

  };


  render() {
    return (
      <div
        className="ag-theme-balham"
        style={{height: '400px', width: '1000px'}}
      >
        <AgGridReact
          columnDefs={this.state.columnDefs}
          rowData={this.state.rowData}>
        </AgGridReact>
      </div>
    );
  }
}

export default TradeTable;
